import { render } from "./HeroError.vue?vue&type=template&id=95aa7402&scoped=true"
import script from "./HeroError.vue?vue&type=script&lang=js"
export * from "./HeroError.vue?vue&type=script&lang=js"

import "./HeroError.vue?vue&type=style&index=0&id=95aa7402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95aa7402"]])

export default __exports__